import { Component, OnInit,ViewChild ,ElementRef} from '@angular/core';
import { Router} from "@angular/router"
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '@app/_services';

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css']
})
export class NavHeaderComponent implements OnInit {
  @ViewChild("app-nav-header", {static: false}) button;

  title = 'appBootstrap';
  message:string;

  closeResult: string;
  private sidebarVisible:boolean;
  private toggleButton;

  public isCollapsed = true;
  userName: string = "";
  userRole: string ="";
  userImage :string = "";
  constructor(private router: Router,private modalService: NgbModal, private data: DataService,private element : ElementRef) {         this.sidebarVisible = false;
  }

  ngOnInit(): void {
    this.data.currentMessage.subscribe(message => this.message = message)
    var navbar : HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
   });

    this.data.getUserInfo().subscribe(userInfo => {
      this.loadUserInfo();
    })
    this.loadUserInfo();

  }
  loadUserInfo(){
    var userdata = localStorage.getItem('userInformation');
    var parsedUserData = JSON.parse(userdata);
    if(parsedUserData) {
      this.userName = parsedUserData.first_name+" "+parsedUserData.last_name;
      this.userRole = parsedUserData.role_name;
      this.userImage = parsedUserData.profile_picture;
    }
  }
  sidebarToggle() {
    if (this.sidebarVisible === false) {
        this.sidebarOpen();
    } else {
        this.sidebarClose();
    }
  }
  sidebarOpen() {
      const toggleButton = this.toggleButton;
      const html = document.getElementsByTagName('html')[0];
      const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
      setTimeout(function(){
          toggleButton.classList.add('toggled');
      }, 500);
      html.classList.add('nav-open');
      if (window.innerWidth < 991) {
        mainPanel.style.position = 'fixed';
      }
      this.sidebarVisible = true;
  };
  sidebarClose() {
      const html = document.getElementsByTagName('html')[0];
      const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
      if (window.innerWidth < 991) {
        setTimeout(function(){
          mainPanel.style.position = '';
        }, 500);
      }
      this.toggleButton.classList.remove('toggled');
      this.sidebarVisible = false;
      html.classList.remove('nav-open');
  };


  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
}

